// Copyright 2016 Sorama B.V.

export class HardwareServiceError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = "HardwareServiceError";
    }
}
